module.exports = __webpack_public_path__ + "1bbf33d728627b4bf192261aac830bbf.pdf";